import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { ChartDoughnut, FooterReport, Gap, GridInline, LabelTitle, Line, ProgressBar, LabelLevel } from "../../../../components/Global";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";
import PageThree from "./PageThree";
import LoadingPage from "./LoadingPage";
import { Chart, registerables } from "chart.js";
import { Col, Row } from "react-bootstrap";
// import jsonFile from "./rpt-pmt-merdekaBelajar.json";
// import jsonRiasec from "./rpt-pmt-riasec.json";
Chart.register(...registerables);

const PageTwo = ({ idJadwalCbt, idKelas, kodeTahunAjaran, schoolName, isRiasec }) => {
  const [fetching, setFetching] = useState(false);
  const [dataDetailPsi, SetDataDetailPsi] = useState([]);
  const [detailLs, SetDetailLs] = useState([]);
  const [dataRataPencapaianKognitif, SetRataPencapaianKognitif] = useState([]);
  const [dataAq, SetDataAq] = useState([]);
  const [dataEq, SetDataEq] = useState([]);
  const [dataAm, SetDataAm] = useState([]);
  const [dataRiasec, SetDataRiasec] = useState([]);
  const [dataRiasecR, SetDataRiasecR] = useState([]);
  const [dataRiasecI, SetDataRiasecI] = useState([]);
  const [dataRiasecA, SetDataRiasecA] = useState([]);
  const [dataRiasecS, SetDataRiasecS] = useState([]);
  const [dataRiasecE, SetDataRiasecE] = useState([]);
  const [dataRiasecC, SetDataRiasecC] = useState([]);
  const [openPage, setOpenPage] = useState(false);

  const today = new Date();
  const suflix = today.getHours() >= 12 ? " PM" : " AM";
  const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

  useEffect(() => {
    const getDatas = async () => {
      setFetching(true);
      const response = await accountManagement
        .post(CONFIG_DEV.REPORT_PEMETAAN_PAGE_TWO, {
          idJadwalCbt: idJadwalCbt,
          idKelas: idKelas,
          kodeTahunAjaran: kodeTahunAjaran,
        })
        .catch(function (error) {
          console.error("Error Response Page Two", error);
        });

      if (response) {
        if (response.data.data) {
          const responseAPI = response.data.data;
          console.log("====================================");
          console.log("Response Page Two ", responseAPI);
          console.log("====================================");

          SetDetailLs(responseAPI.detailLs);
          SetDataDetailPsi(responseAPI.detailPsi);
          SetRataPencapaianKognitif(responseAPI.rataPencapaianKognitif);
          SetDataAq(responseAPI.detailPsi[0]);
          SetDataEq(responseAPI.detailPsi[1]);
          SetDataAm(responseAPI.detailPsi[2]);
          setOpenPage(true);
        }
      }

      if (isRiasec) {
        const responseRiasec = await accountManagement
          .post(CONFIG_DEV.REPORT_PEMETAAN_PAGE_TWO_RIASEC, {
            idJadwalCbt: idJadwalCbt,
            idKelas: idKelas,
            kodeTahunAjaran: kodeTahunAjaran,
          })
          .catch(function (error) {
            console.error("Error Response Riasec Page Two", error);
          });

        if (responseRiasec) {
          if (responseRiasec.data.data) {
            const responseAPIRiasec = responseRiasec.data.data;

            SetDataRiasec(responseAPIRiasec);
            console.log("====================================");
            console.log("riasec", responseAPIRiasec[0].prosentase);
            console.log("====================================");
          }
        }

        // /pemetaan/reportsekolah_riasec
      } else {
        console.log("====================================");
        console.log("bukan riasec");
        console.log("====================================");
      }
    };
    getDatas();
  }, []);

  const options = {
    responsive: true,
    legend: {
      display: false,
      position: "bottom",
      labels: {
        fontSize: 14,
        fontColor: "#616469",
        fontFamily: "Calibri",
      },
    },
    plugins: {
      datalabels: {
        display: false,
        formatter: (value) => {
          return value + "%";
        },
        color: "#fff",
        font: {
          size: 9,
          weight: "bold",
        },
      },
    },
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  };

  const labels = ["Adversity Qoutient", "Emotional Qoutient", "Achievement Motivation"];

  let data = {
    labels: labels,
    datasets: [
      {
        label: dataAq.keterangan,
        data: [dataAq.prosentaseBawah, dataEq.prosentaseBawah, dataAm.prosentaseBawah],
        backgroundColor: "#C4161C",
      },
      {
        label: dataEq.keterangan,
        data: [dataAq.prosentaseTengah, dataEq.prosentaseTengah, dataAm.prosentaseTengah],
        backgroundColor: "#FB8500",
      },
      {
        label: dataAm.keterangan,
        data: [dataAq.prosentaseAtas, dataEq.prosentaseAtas, dataAm.prosentaseAtas],
        backgroundColor: "#457B9D",
      },
      // {
      //     label: "test1",
      //     data: chartData,
      //     backgroundColor: chartColor,
      // },
    ],
  };

  require("../Pemetaan.css");
  return (
    <div>
      {isRiasec && (
        <div className="report-page">
          <div className="cardLine">
            {/* header */}
            <div className="pnl-header">
              <div className="card-page">
                <span style={{
                  fontSize: '26px',
                  color: '#FFF',
                  fontWeight: 500,
                  fontFamily: 'lucida grande'
                }}>02</span>
              </div>
              <div className="pnl-date">
                https://eduprime.co.id/
              </div>
            </div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <span className="title-header2" style={{ color: '#015E56', fontSize: '25px', }}>Hasil Asesmen Diagnostik</span>
                <p style={{ color: '#015E56', fontSize: '24px', fontWeight: '500', marginTop: '10px' }}>{schoolName} </p>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', }}>
                <div className="label-sub-tit">
                  <span style={{ color: '#FFF', fontSize: '20px', fontWeight: '700' }}>SEKOLAH</span>
                </div>
              </div>
            </div>
            <div className="card-profile" style={{ marginTop: '5%' }}>
              <div style={{ width: '100%', display: 'flex', gap: '20px' }}>
                <div style={{ width: '35%' }}>
                  <div >
                    <ChartDoughnut style={{ width: '280px' }}
                      valueChart={dataRiasec.map((item) => {
                        return item.prosentase;
                      })}
                      chartColor={["#C4161C", "#1D3557", "#5C95FF", "#FFB703", "#944EBA", "#52B788"]}
                      chartLabel={dataRiasec.map((item) => {
                        return item.kodeAspekNonAkademik;
                      })}
                      // legend={false}
                      datalabels={false}
                    />
                  </div>
                </div>
                <div style={{ width: '65%' }}>
                  <div className="card-tbl">
                    <div className="tbl-head">
                      <GridInline width={"100%"} padding={15} marginLeft={15}>
                        <GridInline width={"25%"} marginLeft={15} paddingTop={10} paddingBottom={10}>
                          <LabelTitle label={"Keterangan"} size={20} bolder={800} color={"#000"} />
                        </GridInline>
                        <GridInline width={"25%"} textAlign={"center"}>
                          <LabelTitle label={"Jumlah Siswa"} size={20} bolder={800} color={"#000"} />
                        </GridInline>
                        <GridInline width={"25%"} textAlign={"center"}>
                          <LabelTitle label={"Prosentase"} size={20} bolder={800} color={"#000"} />
                        </GridInline>
                      </GridInline>
                    </div>
                    <div className="table-result">
                      {dataRiasec.map((itemRiasec, i) => {
                        return (
                          <div key={i} style={{ marginBottom: '5px' }}>
                            <GridInline width={"100%"} padding={15} marginLeft={15}>
                              <GridInline width={"25%"} marginLeft={15} paddingTop={10}>
                                <LabelLevel color={'#FFF'} level={itemRiasec.kodeAspekNonAkademik}
                                  bgColor={itemRiasec.kodeAspekNonAkademik == "Realistic" ? "#C4161C"
                                    : itemRiasec.kodeAspekNonAkademik == "Investigative" ? "#1D3557"
                                      : itemRiasec.kodeAspekNonAkademik == "Artistic" ? "#5C95FF"
                                        : itemRiasec.kodeAspekNonAkademik == "Social" ? "#FFB703"
                                          : itemRiasec.kodeAspekNonAkademik == "Enterprising" ? "#944EBA"
                                            : itemRiasec.kodeAspekNonAkademik == "Conventional" ? "#52B788"
                                              : "#C4161C"}
                                />
                              </GridInline>
                              <GridInline width={"25%"} textAlign={"center"}>
                                {itemRiasec.jumlahSiswa} Siswa
                              </GridInline>
                              <GridInline width={"25%"} textAlign={"center"}>
                                {itemRiasec.prosentase.toFixed(2)}%
                              </GridInline>
                            </GridInline>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Gap height={20} />
              <LabelTitle label={"Deskripsi Asesmen Bakat Minat"} size={18} bolder={700} color={"#212529"} />
              <Gap height={20} />
              <div className="tbl-head">
                <div style={{ width: '15%' }}>
                  <span style={{ fontSize: '20px', fontWeight: '600' }}>Karakteristik</span>
                </div>
                <div>
                  <span style={{ fontSize: '20px', fontWeight: '600' }}>Deskripsi</span>
                </div>
              </div>
              <div className="table-result" style={{ border: '1px solid #E0E0E0' }}>
                {dataRiasec.map((itemRiasecTable, i) => {
                  return (
                    <div key={i} style={{ width: '100%', display: 'flex', padding: '12px', borderBottom: '1px solid #E0E0E0' }}>
                      <div style={{ width: '15%' }}>
                        <span style={{ fontSize: '16px', fontWeight: '500' }}>{itemRiasecTable.kodeAspekNonAkademik}</span>
                      </div>
                      <div style={{ width: '85%' }}>
                        <span style={{ fontSize: '16px', fontWeight: '500' }}>{itemRiasecTable.keterangan}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      )}
      {/* pagge 3 */}
      <div className="report-page">
        <div className="cardLine">
          {/* header */}
          <div className="pnl-header">
            <div className="card-page">
              <span style={{
                fontSize: '26px',
                color: '#FFF',
                fontWeight: 500,
                fontFamily: 'lucida grande'
              }}>03</span>
            </div>
            <div className="pnl-date">
              https://eduprime.co.id/
            </div>
          </div>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <span className="title-header2" style={{ color: '#015E56', fontSize: '25px', }}>Hasil Asesmen Diagnostik </span>
              <p style={{ color: '#015E56', fontSize: '24px', fontWeight: '500', marginTop: '10px' }}>{schoolName} </p>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div className="label-sub-tit">
                <span style={{ color: '#FFF', fontSize: '20px', fontWeight: '700' }}>SEKOLAH</span>
              </div>
            </div>
          </div>
          <Gap height={50} />
          <div className="card-profile">
            <div className="result">
              <LabelTitle label={"Hasil Asesmen Learning Style"} size={18} bolder={700} color={"#212529"} />
              <Gap height={20} />
              <div className="rekap-table">
                <GridInline width={"40%"} verticalAlign={"top"} paddingTop={50}>
                  <ChartDoughnut
                    valueChart={[detailLs.auditori, detailLs.visual, detailLs.kinestetik]}
                    chartColor={["#C4161C", "#1D3557", "#FB8500"]}
                    chartLabel={["Auditori", "Visual", "Kinestetik"]}
                    // legend={false}
                    datalabels={false}
                  />
                </GridInline>
                <GridInline width={"60%"}>
                  <LabelTitle label={"Keterangan :"} size={17} bolder={600} color={"#495057"} />
                  <Gap height={10} />
                  <GridInline width={"20%"}>
                    <LabelTitle label={"Auditori"} size={16} bolder={400} color={"#616469"} />
                    <Gap height={5} />
                    <LabelTitle label={detailLs.auditori + " Siswa"} size={16} bolder={400} color={"#616469"} />
                  </GridInline>
                  <GridInline width={"20%"}>
                    <LabelTitle label={"Visual"} size={16} bolder={400} color={"#616469"} />
                    <Gap height={5} />
                    <LabelTitle label={detailLs.visual + " Siswa"} size={16} bolder={400} color={"#616469"} />
                  </GridInline>
                  <GridInline width={"20%"}>
                    <LabelTitle label={"Kinestetik"} size={16} bolder={400} color={"#616469"} />
                    <Gap height={5} />
                    <LabelTitle label={detailLs.kinestetik + " Siswa"} size={16} bolder={400} color={"#616469"} />
                  </GridInline>
                  <Gap height={16} />
                  <LabelTitle label={"Saran Pengelolaan Kelas :"} size={17} bolder={600} color={"#495057"} />
                  <Gap height={10} />
                  <LabelTitle label={"Visual"} size={16} bolder={600} color={"#495057"} />
                  <Gap height={5} />
                  <LabelTitle
                    label={
                      "Ajarkan siswa siswi anda menggunakan mind map (peta konsep) dengan berbagai warna,karena siswa dengan kemampuan visual mudah mengingat dan memahami materi pada mind map dengan warna yang bervariasi. Jika memungkinkan, putarkan video pembelajaran"
                    }
                    size={16}
                    bolder={400}
                    color={"#616469"}
                  />
                  <Gap height={10} />
                  <LabelTitle label={"Auditori"} size={16} bolder={600} color={"#495057"} />
                  <Gap height={5} />
                  <LabelTitle
                    label={
                      "Ajak siswa untuk aktif dalam diskusi. Biarkan siswa membaca materi pelajaran dengan keras karena mereka akan lebih cepat memahami materi jika membaca sambal mendengarkan apa yang dibaca. Jika siswa tidak mencatat di kelas, jangan terburu-buru memarahi, karena siswa dengan tipe auditory akan menangkap materi dengan cara mendengarkan."
                    }
                    size={16}
                    bolder={400}
                    color={"#616469"}
                  />
                  <Gap height={10} />
                  <LabelTitle label={"Kinestetik"} size={16} bolder={600} color={"#495057"} />
                  <Gap height={5} />
                  <LabelTitle label={"Ajaklah siswa untuk lebih banyak melakukan praktikum. Berikan ‘ice breaking’ setelah 20 atau 30 menit belajar."} size={16} bolder={400} color={"#616469"} />
                </GridInline>
              </div>
            </div>
          </div>

          <div className="card-profile">
            <div>
              <LabelTitle label={"Rata-Rata Pencapaian Kognitif Mata Pelajaran"} size={18} bolder={700} color={"#212529"} />
              <Gap height={10} />
            </div>
            <div style={{ width: '100%' }}>
              {dataRataPencapaianKognitif.map((rataKognitif, i) => {
                return (
                  <div key={i} style={{ display: 'flex', gap: '10px', padding: '7px' }}>
                    <div style={{ width: '20%' }}>
                      <LabelTitle label={rataKognitif.namaMataPelajaran} size={16} bolder={500} color={"#616469"} />
                    </div>
                    <div style={{ width: '75%' }}>
                      <ProgressBar progressColor={"#FB8500"} progressValue={rataKognitif.totalSkor} heightBar={22} />
                    </div>
                    <div style={{ width: '5%' }}>
                      <LabelTitle label={rataKognitif.totalSkor} size={16} bolder={500} color={"#616469"} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      {/* page 4 */}
      <div className="report-page">
        <div className="cardLine">
          {/* header */}
          <div className="pnl-header">
            <div className="card-page">
              <span style={{
                fontSize: '26px',
                color: '#FFF',
                fontWeight: 500,
                fontFamily: 'lucida grande'
              }}>04</span>
            </div>
            <div className="pnl-date">
              https://eduprime.co.id/
            </div>
          </div>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
            <div>
              <span className="title-header2" style={{ color: '#015E56', fontSize: '25px', }}>Hasil Asesmen Diagnostik </span>
              <p style={{ color: '#015E56', fontSize: '24px', fontWeight: '500', marginTop: '10px' }}>{schoolName} </p>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div className="label-sub-tit">
                <span style={{ color: '#FFF', fontSize: '20px', fontWeight: '700' }}>SEKOLAH</span>
              </div>
            </div>
          </div>
          <Gap height={50} />
          <div className="card-profile">
            <div className="result" style={{ width: '100%' }}>
              <LabelTitle label={"Rata-Rata Hasil Psychology Potential"} size={18} bolder={700} color={"#212529"} />

              <Gap height={20} />

              <Bar data={data} options={options} />

              <Gap height={20} />

              <GridInline width={"100%"}>
                <GridInline width={"33%"}>
                  <LabelTitle label={"Adversity Qoutient"} size={17} bolder={500} color={"#212529"} />
                  <div
                    style={{
                      display: "inline-block",
                      width: "10%",
                      backgroundColor: "#457B9D",
                      height: 15,
                      paddingBottom: 11,
                    }}
                  >
                    &nbsp;
                  </div>
                  <GridInline width={"90%"} paddingLeft={"5%"}>
                    <LabelTitle label={"Rata-Rata Atas " + dataAq.prosentaseAtas + "%"} size={16} bolder={500} color={"#212529"} />
                  </GridInline>
                  <Gap height={10} />
                  <div
                    style={{
                      display: "inline-block",
                      width: "10%",
                      backgroundColor: "#FB8500",
                      height: 15,
                      paddingBottom: 11,
                    }}
                  >
                    &nbsp;
                  </div>
                  <GridInline width={"90%"} paddingLeft={"5%"}>
                    <LabelTitle label={"Rata-Rata " + dataAq.prosentaseTengah + "%"} size={16} bolder={500} color={"#212529"} />
                  </GridInline>
                  <Gap height={10} />
                  <div
                    style={{
                      display: "inline-block",
                      width: "10%",
                      backgroundColor: "#C4161C",
                      height: 15,
                      paddingBottom: 11,
                    }}
                  >
                    &nbsp;
                  </div>
                  <GridInline width={"90%"} paddingLeft={"5%"}>
                    <LabelTitle label={"Rata-Rata Bawah " + dataAq.prosentaseBawah + "%"} size={16} bolder={500} color={"#212529"} />
                  </GridInline>
                </GridInline>
                <GridInline width={"33%"}>
                  <LabelTitle label={"Emotional Qoutient"} size={17} bolder={500} color={"#212529"} />
                  <div
                    style={{
                      display: "inline-block",
                      width: "10%",
                      backgroundColor: "#457B9D",
                      height: 15,
                      paddingBottom: 11,
                    }}
                  >
                    &nbsp;
                  </div>
                  <GridInline width={"90%"} paddingLeft={"5%"}>
                    <LabelTitle label={"Rata-Rata Atas " + dataEq.prosentaseAtas + "%"} size={16} bolder={500} color={"#212529"} />
                  </GridInline>
                  <Gap height={10} />
                  <div
                    style={{
                      display: "inline-block",
                      width: "10%",
                      backgroundColor: "#FB8500",
                      height: 15,
                      paddingBottom: 11,
                    }}
                  >
                    &nbsp;
                  </div>
                  <GridInline width={"90%"} paddingLeft={"5%"}>
                    <LabelTitle label={"Rata-Rata " + dataEq.prosentaseTengah + "%"} size={16} bolder={500} color={"#212529"} />
                  </GridInline>
                  <Gap height={10} />
                  <div
                    style={{
                      display: "inline-block",
                      width: "10%",
                      backgroundColor: "#C4161C",
                      height: 15,
                      paddingBottom: 11,
                    }}
                  >
                    &nbsp;
                  </div>
                  <GridInline width={"90%"} paddingLeft={"5%"}>
                    <LabelTitle label={"Rata-Rata Bawah " + dataEq.prosentaseBawah + "%"} size={16} bolder={500} color={"#212529"} />
                  </GridInline>
                </GridInline>
                <GridInline width={"33%"}>
                  <LabelTitle label={"Achievement Motivation"} size={17} bolder={500} color={"#212529"} />
                  <div
                    style={{
                      display: "inline-block",
                      width: "10%",
                      backgroundColor: "#457B9D",
                      height: 15,
                      paddingBottom: 11,
                    }}
                  >
                    &nbsp;
                  </div>
                  <GridInline width={"90%"} paddingLeft={"5%"}>
                    <LabelTitle label={"Rata-Rata Atas " + dataAm.prosentaseAtas + "%"} size={16} bolder={500} color={"#212529"} />
                  </GridInline>
                  <Gap height={10} />
                  <div
                    style={{
                      display: "inline-block",
                      width: "10%",
                      backgroundColor: "#FB8500",
                      height: 15,
                      paddingBottom: 11,
                    }}
                  >
                    &nbsp;
                  </div>
                  <GridInline width={"90%"} paddingLeft={"5%"}>
                    <LabelTitle label={"Rata-Rata " + dataAm.prosentaseTengah + "%"} size={16} bolder={500} color={"#212529"} />
                  </GridInline>
                  <Gap height={10} />
                  <div
                    style={{
                      display: "inline-block",
                      width: "10%",
                      backgroundColor: "#C4161C",
                      height: 15,
                      paddingBottom: 11,
                    }}
                  >
                    &nbsp;
                  </div>
                  <GridInline width={"90%"} paddingLeft={"5%"}>
                    <LabelTitle label={"Rata-Rata Bawah " + dataAm.prosentaseBawah + "%"} size={16} bolder={500} color={"#212529"} />
                  </GridInline>
                </GridInline>
              </GridInline>
            </div>
          </div>
        </div>
      </div>
      {openPage ? <PageThree idJadwalCbt={idJadwalCbt} idKelas={idKelas} kodeTahunAjaran={kodeTahunAjaran} schoolName={schoolName} /> : <LoadingPage />}
    </div >
  );
};

export default PageTwo;
